import moment from 'moment';
import 'moment-timezone';

moment.tz.setDefault('Asia/Seoul');

export class MomentService {
  static instance: MomentService | null = null;

  static getInstance(): MomentService {
    if (!MomentService.instance) {
      MomentService.instance = new MomentService();
    }
    return MomentService.instance;
  }

  getDateFormat(date: Date | string | number, format = 'YYYY-MM-DD'): string {
    return moment(date).format(format);
  }

  subtractMonth(date: Date | string | number, month: number, format = 'YYYY-MM-DD'): string {
    return moment(date).subtract(month, 'M').format(format);
  }

  getDateDate(days: number, format = 'YYYYMMDD'): string {
    return moment(new Date()).add(days, 'days').format(format);
  }

  getDateDateTime(hours: number, format = 'YYYYMMDDHH'): string {
    return moment(new Date()).add(hours, 'hours').format(format);
  }
}
